import { render } from "./LayerLegendImage.vue?vue&type=template&id=261f6f43"
import script from "./LayerLegendImage.vue?vue&type=script&lang=js"
export * from "./LayerLegendImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__